module.exports = __webpack_public_path__ + "img/barrier_1.04a2306c.png";